import React from 'react'
import Logo from './header-components/logo'
import Nav from './article-components/nav'

import headerStyles from './header.module.scss'

const Header = ({ article, belowFold, visible }) => {
  return (
    <header
      className={`container-fluid ${headerStyles.header} ${belowFold &&
        headerStyles.headerBelowFold} ${visible === false &&
        headerStyles.headerHidden}`}
    >
      <div className={`container ${headerStyles.logoContainer}`}>
        <div className="row">
          <div className={`col-xs-12 ${headerStyles.logoColumn}`}>
            <a
              href="https://reporterbrasil.org.br/"
              className={headerStyles.logo}
              target="_blank"
              rel="noreferrer noopener"
            >
              <Logo belowFold={belowFold} />
            </a>
            <Nav article={article} belowFold={belowFold} />
          </div>
        </div>
      </div>
    </header>
  )
}

export default Header
